import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Service that can update page titles!
 */
export class TitleService {
  /**
   * @constructor
   */
  constructor(
    private readonly title: Title,
    private readonly transloco: TranslocoService
  ) {}

  /**
   * Updates title
   * @param {string} title is an untranslated string
   * @return {Promise<string>}
   */
  async setTitle(title: string): Promise<string> {
    const translatedTitle = await firstValueFrom(
      this.transloco.selectTranslate(title)
    );
    this.title.setTitle(translatedTitle);
    return translatedTitle;
  }
}
